import { CreateEvent } from '../../utils';
import { RecordsQueue } from './Queue';

import { Body } from '../../types/index';
import { EVENT_ADDED_XHR_RECORD } from '../../constants';

// eslint-disable-next-line require-jsdoc
export const xhrPatch = function xhr(XMLHttpRequest: XMLHttpRequest) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { send, open } = XMLHttpRequest.prototype;
  const addedXhrRecordEvent = CreateEvent(EVENT_ADDED_XHR_RECORD);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line prettier/prettier
  XMLHttpRequest.prototype.open = function(...args) {
    const [method, url] = args;

    // eslint-disable-next-line no-console
    this.method = method;
    this.startDateTime = new Date().toISOString();
    this.dataUrl = `${location.protocol}//${location.host}${url}`;
    return open.apply(this, args);
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line prettier/prettier
  XMLHttpRequest.prototype.send = function(body: Body) {
    this.addEventListener('loadend', () => {
      // eslint-disable-next-line no-console
      RecordsQueue.enqueue({
        method: this.method ?? 'undefined',
        statusText: this.statusText,
        responseURL: this.responseURL ? this.responseURL : this.dataUrl,
        status: this.status,
        timeout: this.timeout,
        readyState: this.readyState,
        response: this.response,
        responseText: this.responseText,
        responseHeaders: this.getAllResponseHeaders(),
        startDateTime: this.startDateTime,
        body,
      });
      document.dispatchEvent(addedXhrRecordEvent);
    });

    return send.apply(this, [body]);
  };
};
